import { cim } from './cim'

const routers = [
  {
    path: '/',
    name: 'Redirect',
    component: () => import('@/views/newLogin/redirect.vue'),
  },
  // 重置密码
  {
    path: '/reset_password/:type/:step', // account detail
    name: 'ResetPassword',
    component: () => import('@/views/reset-password/index.vue'),
  },
  // 注册
  // 注册类型-type:phone|email 步骤-step:account|detail/详细账号
  {
    path: '/register/:type/:step', // account detail
    name: 'Register',
    component: () => import('@/views/register/index.vue'),
  },
  // 领英登录
  {
    path: '/linkedin',
    name: 'linkedin',
    component: () => import('@/views/login/Linkedin'),
  },
  // 新登陆页
  // 登陆类型-type:phone/email 步骤-step:account/detail 账号-account
  {
    path: '/login/:type/:step',
    name: 'newLogin',
    component: () => import('@/views/newLogin/login'),
  },
  // 补充个人信息页面
  {
    path: '/personalinfo',
    name: 'personalInfo',
    component: () => import('@/views/personalInfo/index'),
  },
  // 友邦登录页面
  {
    path: '/aia',
    name: 'aia',
    component: () => import('@/views/login/aia/Aia.vue'),
  },
  {
    path: '/aia-agent',
    name: 'aia-agent',
    component: () => import('@/views/login/aia/AiaAgent.vue'),
  },
  {
    path: '/aia-phone',
    name: 'aia-phone',
    component: () => import('@/views/login/aia/AiaPhone.vue'),
  },
  // 友邦HR登录页面
  {
    path: '/aia-hr',
    name: 'aia-hr',
    component: () => import('@/views/login/aia-hr/Aia.vue'),
  },
  {
    path: '/aia-hr-agent',
    name: 'aia-hr-agent',
    component: () => import('@/views/login/aia-hr/AiaAgent.vue'),
  },
  {
    path: '/hr-job-number',
    name: 'HrJobNumber',
    component: () => import('@/views/login/porsche-hr/BindJobNumber.vue'),
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404.vue'),
  },
  {
    path: '*', // 404 页面
    redirect: '/404',
  },
  ...cim,
]

// 智联招聘(zl), 保时捷(porsche718, porsche911, porschetaycan, hr), 友邦(aia)，南京银行二期
const customLoginItems = [
  'zl',
  'porsche718',
  'porsche911',
  'porschetaycan',
  'njcb-meets',
  'takedaspark',
  'hr',
  'nissan',
  'aiahrn',
  // 'aia',
]

for (const name of customLoginItems) {
  routers.push({
    path: `/${name}`,
    name,
    component: () => import('@/views/login/CustomLogin'),
  })
}

export default routers
